import { render, staticRenderFns } from "./deleteMaster.vue?vue&type=template&id=b3c61ae6"
import script from "./deleteMaster.vue?vue&type=script&lang=js"
export * from "./deleteMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports